import { IGif } from '@giphy/js-types'
import React, { FC, SyntheticEvent, useCallback, useRef, useEffect } from 'react'
import { useLocation } from 'react-router'
import GAEventContext from './ga-events'
import routes, { getRouteFromPathname } from 'shared/routes'
import { googleAnalyticsEvent } from 'shared/util/analytics'

type Props = {}

const getCategoryFromPathname = (pathname: string) => {
    const route = getRouteFromPathname(pathname)
    switch (route) {
        case routes.GIF_DETAIL:
            return 'GIF Detail'
        case routes.CHANNEL:
            return 'channel'
        default:
            console.error(`GA event manager, no pathname match for ${pathname}`)
            return ''
    }
}

const GAEventContextManager: FC<Props> = ({ children }) => {
    const { pathname } = useLocation()
    const onGifClick = useCallback(
        (gif: IGif, _e: SyntheticEvent<HTMLElement, Event>) => {
            const category = getCategoryFromPathname(pathname)
            googleAnalyticsEvent({ category, label: gif.id, action: 'GIF Click' })
        },
        [pathname]
    )
    const onGifRightClick = useCallback(
        (gif: IGif, _e: SyntheticEvent<HTMLElement, Event>) => {
            const category = getCategoryFromPathname(pathname)
            googleAnalyticsEvent({ category, label: gif.id, action: 'GIF Right Click' })
        },
        [pathname]
    )
    const onGifFavorite = useCallback(
        (gif: IGif) => {
            const category = getCategoryFromPathname(pathname)
            googleAnalyticsEvent({ category, label: gif.id, action: 'Favorite' })
        },
        [pathname]
    )
    const onLinkCopy = useCallback(
        (gif: IGif) => {
            const category = getCategoryFromPathname(pathname)
            googleAnalyticsEvent({ category, label: gif.id, action: 'GIF Copy Link' })
        },
        [pathname]
    )
    const value = useRef({ onGifClick, onGifRightClick, onGifFavorite, onLinkCopy })
    useEffect(() => {
        value.current = { onGifClick, onGifRightClick, onGifFavorite, onLinkCopy }
    }, [pathname])
    return <GAEventContext.Provider value={value.current}>{children}</GAEventContext.Provider>
}

export default GAEventContextManager
